import { Body } from '@big-red-group/storefront-common-ui'
import { Switch, ToggleWrap } from './ToggleSwitch.styles'

const ToggleSwitch: React.FC<{
  handleOnChange: (value: boolean) => void
  isChecked: boolean
  id: string
  label?: string
}> = ({ handleOnChange, isChecked, id, label }) => {
  return (
    <ToggleWrap>
      <Switch htmlFor={id} checked={isChecked}>
        <input
          id={id}
          type="checkbox"
          checked={isChecked}
          onChange={() => {
            handleOnChange(!isChecked)
          }}
        />
      </Switch>
      {label && <Body as="span">{label}</Body>}
    </ToggleWrap>
  )
}
export default ToggleSwitch
